import React from "react";
import LogoAmpmMini from "../../../icons/footer-ampm.svg";
import LogoDamixaMini from "../../../icons/footer-damixa.svg";
import LogoDorffMini from "../../../icons/footer-dorff.svg";
import ArrowUp from "../../../icons/arrow-up.svg";
import * as S from "./styled/index";
import {changePolicyModalState} from "@app/store/core/slice";
import {useAppDispatch} from "@app/store";

const Footer = () => {
  const dispatch = useAppDispatch();

  const handleToTopButtonClick = (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    evt.preventDefault();
    window.scrollTo(0, 0);
  };

  const policyHandler = () => {
    dispatch(changePolicyModalState({ visibility: true }));
    window.scrollTo(0, 0);
  }


  return (
    <S.FooterContainer>
      <S.FooterWrapper>
        <S.FooterRow>
          <S.TopRowContainer>
            <S.BrandsWrap>
              <LogoAmpmMini />
              <LogoDamixaMini />
              <LogoDorffMini />
            </S.BrandsWrap>
            <S.ButtonToTop isMobile onClick={handleToTopButtonClick}>
              <ArrowUp />
            </S.ButtonToTop>
          </S.TopRowContainer>
          <S.NavWrapper>
            <S.FooterNav>
              <S.FooterLink href="/contacts">Контакты</S.FooterLink>
              <S.FooterLinkLk href="/profile">Личный кабинет</S.FooterLinkLk>
              <S.ButtonToTop isDesktop onClick={handleToTopButtonClick}>
                <ArrowUp />
              </S.ButtonToTop>
            </S.FooterNav>
          </S.NavWrapper>
        </S.FooterRow>
        <S.FooterRow>
          <S.CopyrightRow>
            <S.Copyright>
              <p>
                © ООО «Сервис Центр». Все права защищены.
                <S.PolicyTrigger type="button" onClick={policyHandler}>Политика конфиденциальности.</S.PolicyTrigger>
              </p>
              <p>
                Сайт aqua-warranty использует cookie, чтобы сделать пользование сайтом проще. Узнайте больше про использование
                cookie. Информация, представленная на сайте, не является публичной офертой.
              </p>
            </S.Copyright>
            <S.ButtonToTop isTablet onClick={handleToTopButtonClick}>
              <ArrowUp />
            </S.ButtonToTop>
          </S.CopyrightRow>
        </S.FooterRow>
      </S.FooterWrapper>
    </S.FooterContainer>
  );
};

export default Footer;
